module.exports = __webpack_public_path__ + "img/es50_3.99a774ce.png";